module.exports = __webpack_public_path__ + "media/winner_single_line_2.f8d7795e.mp3";